<template>
  <div class="view pa24">
    <div class="">
      <el-row :gutter="24">
        <el-col class="">
          <div class="">
            <div class="wid100">
              <el-input v-model="queryParam.orderNo" class="mb10" style="width: 240px" placeholder="请输入订单号"></el-input>
              <el-input v-model="queryParam.customerNo" class="mb10 ml10" style="width: 240px"
                placeholder="请输入客户代号"></el-input>
              <!-- <el-input v-model="queryParam.planPerson" class="mb10 ml10" style="width: 240px"
                placeholder="请输入计划人员"></el-input> -->
              <el-select v-model="queryParam.planPerson" placeholder="请选择计划人员" class="mb10 ml10" style="width: 240px"
                filterable clearable>
                <el-option v-for="person in planPersons" :key="person.value" :label="person.label" :value="person.value"
                  @click.native.stop>
                  {{person.label}}
                  <!-- <div style="display: flex; align-items: center;">
                    <el-checkbox :checked="queryParam.planPerson.includes(person.value)"
                      @change="handlePlanPersonCheckboxChange(person.value, $event)"  @click.stop>{{person.label}}</el-checkbox>
                  </div> -->
                </el-option>
              </el-select>
              <!-- 出库状态查询 -->
              <el-select v-model="queryParam.status" :key="selectOutKey" placeholder="出库状态" class="mb10 ml10"
                style="width: 240px" multiple collapse-tags filterable>
                <!-- 三种状态  直接写出来  0未出库  1部分出库  2已出库 -->
                <el-option v-for="item in ckStatusList" :key="item.value" :label="item.label" :value="item.value"
                  @click.native.stop> <!-- 阻止默认点击事件 -->
                  <div style="display: flex; align-items: center;">
                    <!-- 添加 el-checkbox 组件，使用 @change 事件手动更新状态 -->
                    <el-checkbox :checked="queryParam.status.includes(item.value)"
                      @change="handleCheckboxChange(item.value, $event)">{{ item.label }}</el-checkbox>
                    <!-- <span style="margin-left: 8px; pointer-events: none;">{{ item.label }}</span> -->
                  </div>
                </el-option>
              </el-select>
              <!-- 入库状态查询 -->
              <el-select v-model="queryParam.rkStatus" :key="selectInKey" placeholder="入库状态" class="mb10 ml10"
                style="width: 240px" multiple collapse-tags filterable>
                <el-option v-for="item in rkStatusList" :key="item.value" :label="item.label" :value="item.value"
                  @click.native.stop> <!-- 阻止默认点击事件 -->
                  <div style="display: flex; align-items: center;">
                    <el-checkbox :checked="queryParam.rkStatus.includes(item.value)"
                      @change="handleRkCheckboxChange(item.value, $event)">{{ item.label }}</el-checkbox>
                    <!-- <span style="margin-left: 8px; pointer-events: none;">{{ item.label }}</span> -->
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="width100">
              <!-- 根据时间查询 -->
              <el-date-picker v-model="queryParam.planDate" type="date" placeholder="计划日期" value-format="yyyy-MM-dd"
                class="mb10" style="width: 240px"></el-date-picker>
              <el-button class="mb10 mgl50" type="primary" @click="getCustomer">搜索</el-button>
              <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
              <el-button class="ml10 mb10" type="primary" @click="openImport">导入 订单</el-button>
              <el-button class="ml10 mb10" type="primary" @click="exportBox">导出 装箱单</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--    <el-button class="ml10 mb10" type="primary" @click="toAdd">新增</el-button>-->

    <el-table :data="tableData" style="width: 100%; margin-bottom: 20px" row-key="id" border
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.details" class="expanded-table"> <!-- 添加类名 -->
            <el-table-column prop="modelNo" align="center" label="型号" />
            <el-table-column prop="className" align="center" label="产品名称" />
            <el-table-column prop="gyNo" align="center" label="工艺号" />
            <el-table-column prop="specCode" align="center" label="规格" />
            <el-table-column prop="num" align="center" label="数量" />
            <el-table-column prop="weight" align="center" label="重量/面积" />
            <el-table-column prop="remarks" align="center" label="备注" />
            <el-table-column prop="outNum" align="center" label="实际出库数量" />
            <el-table-column prop="inNum" align="center" label="实际入库数量" />
            <el-table-column prop="surplusNum" align="center" label="剩余数量" />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" align="center" label="订单号" />
      <el-table-column prop="customerNo" align="center" label="客户代号" />
      <el-table-column prop="planPerson" align="center" label="计划人员" />
      <el-table-column prop="planDate" align="center" label="计划日期" />
      <el-table-column prop="htNo" align="center" label="合同号" />
      <el-table-column prop="deliveryTime" align="center" label="交期" />
      <el-table-column prop="yiz" align="center" label="溢装" />
      <el-table-column prop="status" align="center" label="出库状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="danger">未出库</el-tag>
          <el-tag v-else-if="scope.row.status == 1" type="success">部分出库</el-tag>
          <el-tag v-else-if="scope.row.status == 2" type="warning">已出库</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" label="入库状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.rkStatus == 0" type="danger">未入库</el-tag>
          <el-tag v-else-if="scope.row.rkStatus == 1" type="success">部分入库</el-tag>
          <el-tag v-else-if="scope.row.rkStatus == 2" type="warning">全部入库</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            ">
            <div>
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="del(scope.row)"
                icon="el-icon-info" icon-color="red" title="确定要删除吗？">
                <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
              </el-popconfirm>

              <el-dropdown @command="handleOutCommand($event, scope.row)">
                <span class="el-dropdown-link">
                  出库状态<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">未出库</el-dropdown-item>
                  <el-dropdown-item command="1">部分出库</el-dropdown-item>
                  <el-dropdown-item command="2">已出库</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-button type="text" @click="printBtn(scope.row)" class="ml10">打印</el-button>
              <el-dropdown @command="handleInCommand($event, scope.row)">
                <span class="el-dropdown-link">
                  入库状态<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">未入库</el-dropdown-item>
                  <el-dropdown-item command="1">部分入库</el-dropdown-item>
                  <el-dropdown-item command="2">全部入库</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>

    <el-dialog title="导入订单" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
      <el-form :model="form" label-width="80px">
        <el-upload ref="upload" class="upload-demo" :headers="upParams" drag :action="uploadUrl"
          :on-exceed="handleExceed" :on-error="handleError" :on-success="handleSuccess" multiple accept=".xls,.xlsx"
          :auto-upload="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">确 定</el-button>
      </div>
    </el-dialog>
    <add ref="add"></add>
    <code-print ref="codePrint"></code-print>
  </div>
</template>
<script>
  import {
    selectOrdersList,
    importOrders,
    exportOrders,
    updateStatus,
    updateStatusIn,
  } from "@/api/storeOrders.js";
  import Add from "./component/add.vue";
  import { delOrders } from "@/api/storeOrders";
  import CodePrint from "./component/codePrint.vue";
  // import { baseUrl } from "@/utils/index"
  let baseUrl = process.env.VUE_APP_API_URL;
  export default {
    components: { Add, CodePrint },
    props: {},
    data() {
      let token = localStorage.getItem("token");
      return {
        planPersons: [
          { value: '沈林根', label: '沈林根' },
          { value: '杭新峰', label: '杭新峰' },
          { value: '沈晨豪', label: '沈晨豪' },
          { value: '蒋春燕', label: '蒋春燕' },
          { value: '盛佳瑜', label: '盛佳瑜' },
          { value: '沈豪', label: '沈豪' }
        ],
        uploadUrl: "/api/storeOrders/importExcel",
        upParams: {
          token: token,
        },
        queryParam: {
          orderNo: "",
          customerNo: "",
          planPerson: "",
          planDate: "",
          status: [],
          rkStatus: [],
        },
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        dialogFormVisible: false,
        form: {
          id: "",
          name: "",
          intro: "",
          itemList: [],
          formula: "",
        },
        dynamicTags: ["(", ")", "*", "/", "+", "-"],
        inputVisible: false,
        inputValue: "",
        title: "导入订单",
        rules: {},
        selectedOrderIds: [], // 用于存储选中的订单ID
        ckStatusList: [
          { value: 0, label: "未出库" },
          { value: 1, label: "部分出库" },
          { value: 2, label: "已出库" },
        ],
        rkStatusList: [
          { value: 0, label: "未入库" },
          { value: 1, label: "部分入库" },
          { value: 2, label: "全部入库" },
        ],
        selectOutKey: 1,
        selectInKey: 1
      };
    },
    created() {
      this.getList();
    },
    methods: {
      handlePlanPersonCheckboxChange(value, isChecked) {
        const index = this.queryParam.planPerson.indexOf(value);
        if (isChecked && index === -1) {
          // this.queryParam.planPerson.push(value);
          this.queryParam.planPerson = value;
        } else if (!isChecked && index !== -1) {
          this.queryParam.planPerson.splice(index, 1);
        }
      },
      toAdd() {
        this.$refs.add.init();
      },
      handleCheckboxChange(value, isChecked) {
        const index = this.queryParam.status.indexOf(value);
        if (isChecked && index === -1) {
          this.queryParam.status.push(value);
        } else if (!isChecked && index !== -1) {
          this.queryParam.status.splice(index, 1);
        }
      },
      handleRkCheckboxChange(value, isChecked) {
        const index = this.queryParam.rkStatus.indexOf(value);
        if (isChecked && index === -1) {
          this.queryParam.rkStatus.push(value);
        } else if (!isChecked && index !== -1) {
          this.queryParam.rkStatus.splice(index, 1);
        }
      },
      handleSuccess(response, file, fileList) {
        if (response.code != 200) {
          this.$message.error(response.message);
          this.$refs.upload.clearFiles();
        } else {
          this.$message.success("导入成功");
          this.getList();
          this.dialogFormVisible = false;
        }
      },
      handleError(err, file, fileList) {
        this.$message.error("导入失败");
      },
      handleExceed(files, fileList) {
        this.$message.warning("只能上传1个文件");
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      openImport() {
        this.dialogFormVisible = true;
      },
      resetForm() {
        this.form.id = "";
        this.form.name = "";
        this.form.intro = "";
        this.form.formula = "";
        this.form.itemList = [];
      },
      edit(row) {
        this.form = JSON.parse(JSON.stringify(row));
        this.title = "编辑公式";
        this.dialogFormVisible = true;
      },
      del(row) {
        delOrders({ id: row.id }).then((res) => {
          this.$message.success("删除成功");
          this.getList();
        });
      },
      resetFormula() {
        this.form.formula = "";
      },
      clickTag(tag) {
        this.form.formula = this.form.formula + tag;
      },
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      printBtn(data) {
        this.$refs.codePrint.visiblePrint = true;
        console.log(data.id);
        this.$refs.codePrint.init(data.id);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.form.itemList.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = "";
      },
      getCustomer() {
        this.getList();
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddCode() {
        this.resetForm();
        this.dialogFormVisible = true;
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        params = Object.assign(params, this.queryParam);
        selectOrdersList(params).then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.total;
        });
      },

      getTypeName() { },
      reset() {
        this.queryParam.orderNo = "";
        this.queryParam.customerNo = "";
        this.queryParam.planPerson = "";
        this.queryParam.planDate = "";
        this.queryParam.status = [];
        // 重置为空数组
        this.queryParam.rkStatus = [];
        this.queryParam.planPerson = "";
        this.selectOutKey++
        this.selectInKey++
        this.getList();
      },
      save() {
        if (!this.form.itemList || this.form.itemList.length == 0) {
          this.$message.error("请添加公式项");
          return;
        }
        if (!this.form.formula || this.form.formula.length == 0) {
          this.$message.error("请添加公式");
          return;
        }
        addFormula(this.form).then((res) => {
          this.$message.success("保存成功");
          this.dialogFormVisible = false;
          this.getList();
        });
      },
      handleSelectionChange(selection) {
        this.selectedOrderIds = selection.map((item) => item.id); // 将选中的订单ID保存到数组中
        console.log(this.selectedOrderIds);
      },
      exportBox() {
        // 检查是否有选中的订单
        if (this.selectedOrderIds.length === 0) {
          this.$message({
            type: "warning",
            message: "请先选择要导出的订单",
          });
          return;
        }
        let params = {
          oderIds: this.selectedOrderIds,
        };
        exportOrders(params).then((res) => {
          if (res.code === 200) {
            console.log(res.data);
            let urls = baseUrl + res.data;
            const link = document.createElement("a");
            link.href = urls;
            link.style.display = "none";
            link.download = "装箱单.xlsx"; // 设置下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message({
              type: "success",
              message: "导出成功",
            });
          }
        });
      },
      handleOutCommand(common, row) {
        console.log("common", common, row);
        let obj = {
          0: "未出库",
          1: "部分出库",
          2: "已出库",
        };
        this.$confirm(
          `确定要将该订单的出库状态修改为 ${obj[common]} 状态吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          updateStatus({ orderId: row.id, status: common }).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        });
      },
      handleInCommand(common, row) {
        console.log("common", common, row);
        let obj = {
          0: "未入库",
          1: "部分入库",
          2: "全部入库",
        };
        this.$confirm(
          `确定要将该订单的入库状态修改为 ${obj[common]} 状态吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          updateStatusIn({ orderId: row.id, status: common }).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        });
      }
    },
  };
</script>
<style scoped lang="scss">
  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }

  .wid100 {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .width100 {
    display: flex;
  }

  .mgl50 {
    margin-left: 50px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #51CDCB;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }



  /* 主表格样式，假设主表格没有特别的类名，这里简单设置 */
  .el-table {
    background-color: #f0f0f0;
  }

  .el-table .el-table__header {
    background-color: #e0e0e0;
  }

  .el-table .el-table__body tr {
    background-color: #f0f0f0;
  }

  .el-table .el-table__body tr:hover {
    background-color: #e5e5e5;
  }
</style>